'use client';

import { Box, Container, Paper, Typography } from '@mui/material';

export default function Page() {
  return (
    <div>
      {/* Hero Section */}
      <Box
        sx={{
          height: { xs: '50vh', md: '70vh' },
          backgroundImage: {
            xs: 'url(/assets/images/image-panduan-bg-mobile.webp)',
            md: 'url(/assets/images/image-panduan-bg.webp)',
          },
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'end',
        }}
      >
        <Box
          sx={{
            height: { xs: '70px', md: '100px', lg: '140px' },
            width: '100%',
            background: 'url("/assets/background/background-footer-top.svg")',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'bottom',
          }}
        />
      </Box>

      {/* Content Section */}
      <Box py={{ xs: 10, md: 12 }}>
        <Container>
          <Typography variant="h3" textAlign="center" mb={8}>
            Kebijakan Privasi
          </Typography>

          <Paper
            elevation={8}
            sx={{
              px: { xs: 3, md: 6 },
              py: { xs: 4, md: 6 },
              borderRadius: { xs: '10px', md: '20px' },
            }}
          >
            <Typography variant="h6" gutterBottom>
              Persetujuan terhadap Kebijakan Privasi
            </Typography>
            <Typography paragraph>
              Selamat datang di situs resmi <strong>Puspa Jaya</strong>, layanan pemesanan tiket bus
              online untuk perjalanan dari dan ke Lampung, Sumatera Selatan, Yogyakarta, Banten Jawa
              Tengah, Jawa Timur, dan Jawa Barat. Kami menghargai privasi Anda dan berkomitmen untuk
              melindungi informasi pribadi yang Anda berikan kepada kami saat menggunakan situs ini.
            </Typography>
            <Typography paragraph>
              Dengan mengakses dan menggunakan layanan di situs kami (
              <strong>www.puspajaya.co.id</strong>), Anda menyetujui ketentuan-ketentuan dalam
              Kebijakan Privasi ini. Jika Anda tidak menyetujui salah satu bagian dari kebijakan
              ini, harap tidak melanjutkan penggunaan situs kami.
            </Typography>

            <Typography variant="h6" gutterBottom mt={4}>
              Informasi yang Kami Kumpulkan
            </Typography>
            <Typography paragraph>
              Kami mengumpulkan data yang Anda berikan secara sukarela saat melakukan pemesanan,
              yang meliputi:
            </Typography>
            <ul className="list-disc list-inside mb-4">
              <li>Nama lengkap</li>
              <li>Nomor handphone aktif</li>
              <li>Alamat email</li>
            </ul>
            <Typography paragraph>
              Kami juga dapat secara otomatis menerima informasi teknis ketika Anda mengakses situs
              kami, seperti alamat IP, jenis perangkat dan browser yang Anda gunakan, serta
              informasi penggunaan halaman.
            </Typography>

            <Typography variant="h6" gutterBottom mt={4}>
              Penggunaan Local Storage dan Cache Browser
            </Typography>
            <Typography paragraph>
              Untuk meningkatkan kenyamanan pengguna dan mempercepat waktu muat halaman, situs kami
              menggunakan teknologi seperti <strong>Local Storage</strong> dan{' '}
              <strong>Cache Browser</strong>. Kami menyimpan informasi sementara seperti data
              pemesanan yang sedang berjalan, pilihan rute terakhir, atau referensi promosi agar
              proses pemesanan Anda lebih cepat dan efisien.
            </Typography>
            <Typography paragraph>
              Informasi yang disimpan tidak bersifat sensitif dan tidak dapat digunakan untuk
              mengidentifikasi Anda secara langsung tanpa kombinasi dengan data lain. Anda dapat
              menghapus data ini kapan saja melalui pengaturan browser Anda.
            </Typography>

            <Typography variant="h6" gutterBottom mt={4}>
              Tujuan Penggunaan Data Pribadi
            </Typography>
            <Typography paragraph>Data yang Anda berikan digunakan untuk:</Typography>
            <ul className="list-disc list-inside mb-4">
              <li>Memproses dan mengelola pemesanan tiket</li>
              <li>Mengirimkan e-tiket melalui email</li>
              <li>
                Menghubungi Anda jika terdapat pembatalan, perubahan jadwal, atau informasi penting
                lainnya
              </li>
              <li>Memastikan keamanan transaksi</li>
              <li>Melakukan analisis internal untuk peningkatan kualitas layanan</li>
            </ul>

            <Typography variant="h6" gutterBottom mt={4}>
              Pembayaran yang Aman melalui Midtrans
            </Typography>
            <Typography paragraph>
              Semua transaksi pembayaran di situs Puspa Jaya dilakukan melalui{' '}
              <strong>Midtrans</strong>, penyedia layanan pembayaran yang telah terverifikasi dan
              terpercaya. Sistem Midtrans memproses transaksi dengan tingkat keamanan tinggi dan
              bersertifikasi PCI-DSS. Kami tidak menyimpan informasi kartu debit/kredit Anda di
              server kami.
            </Typography>

            <Typography variant="h6" gutterBottom mt={4}>
              Penyimpanan & Keamanan Data
            </Typography>
            <Typography paragraph>
              Data pengguna disimpan secara terenkripsi dan aman di database{' '}
              <strong>MongoDB</strong>. Kami hanya memberikan akses terbatas kepada staf yang
              berkepentingan dan melakukan audit berkala untuk memastikan keamanan data tetap
              terjaga.
            </Typography>

            <Typography variant="h6" gutterBottom mt={4}>
              Pengungkapan kepada Pihak Ketiga
            </Typography>
            <Typography paragraph>
              Kami tidak menjual, menyewakan, atau menukar data pribadi pengguna kepada pihak ketiga
              untuk tujuan komersial. Namun, kami dapat berbagi data Anda dengan penyedia layanan
              seperti payment gateway (Midtrans) dan sistem email untuk pengiriman tiket, hanya
              dalam konteks memberikan layanan kepada Anda.
            </Typography>

            <Typography variant="h6" gutterBottom mt={4}>
              Hak Anda sebagai Pengguna
            </Typography>
            <Typography paragraph>Anda berhak untuk:</Typography>
            <ul className="list-disc list-inside mb-4">
              <li>Meminta informasi mengenai data pribadi yang kami simpan</li>
              <li>Memperbarui atau memperbaiki informasi Anda</li>
              <li>Meminta penghapusan data pribadi, dengan ketentuan hukum yang berlaku</li>
            </ul>

            <Typography variant="h6" gutterBottom mt={4}>
              Perubahan terhadap Kebijakan Ini
            </Typography>
            <Typography paragraph>
              Puspa Jaya berhak untuk mengubah Kebijakan Privasi ini dari waktu ke waktu. Perubahan
              yang signifikan akan diberitahukan melalui situs web atau melalui email jika
              memungkinkan. Kami mendorong Anda untuk membaca kebijakan ini secara berkala.
            </Typography>

            <Typography variant="h6" gutterBottom mt={4}>
              Kontak
            </Typography>
            <Typography paragraph>
              Jika Anda memiliki pertanyaan, permintaan akses, atau keluhan terkait Kebijakan
              Privasi ini, silakan hubungi kami melalui halaman <strong>Kontak</strong> di situs
              resmi kami atau email ke{' '}
              <a href="mailto:puspajaya.po@gmail.com">puspajaya.po@gmail.com</a>.
            </Typography>
          </Paper>
        </Container>
      </Box>
    </div>
  );
}
